import React, { useState } from "react";
import useAuth from "hooks/useAuth";
import useCurrentUser from "hooks/useCurrentUser";
import usePageContext from "hooks/usePageContext";
import useTranslation from "hooks/useTranslation";
import useUpstreamState from "hooks/useUpstreamState";

import withAuth from "hocs/withAuth";

import ModalLayout from "layouts/Modal";

import { Button, Field, Message } from "components/UI";

export default withAuth(() => {
  const { t } = useTranslation();
  const [, { onClose }] = usePageContext();
  const [auth, { updateEmail, updatePassword }] = useAuth();
  const [currentUser] = useCurrentUser();

  const [error, setError] = useState(null);
  const [email, setEmail] = useUpstreamState(currentUser.email || "");
  const [password, setPassword] = useUpstreamState("");

  return (
    <ModalLayout>
      <div className="w-full max-w-2xl mx-auto px-4">
        <form
          className="flex flex-col items-normal py-4 space-y-2"
          onSubmit={async (event) => {
            event.preventDefault();
            try {
              setError(null);
              if (auth.currentUser.email) {
                await updateEmail(email);
              } else {
                await updateEmail(email);
                await updatePassword(password);
              }
              onClose("/settings/auth");
            } catch (error) {
              setError(error);
            }
          }}
        >
          <div className="space-y-4 p-4 rounded-md bg-card">
            <h1>
              {auth.currentUser.email
                ? t`settings.auth.updateEmail`
                : t`settings.auth.setupEmail`}
            </h1>
            {error && (
              <Message color="error" className="p-4">
                {t(`errors.${error.code}`)}
              </Message>
            )}
            <Field
              variant="contained"
              label={t`profile.emailLabel`}
              placeholder={t`profile.emailPlaceholder`}
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            {!auth.currentUser.email && (
              <Field
                variant="contained"
                label={t`settings.auth.newPassword`}
                placeholder={t`settings.auth.passwordPlaceholder`}
                type="password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            )}
          </div>
          <Button
            color="primary"
            disabled={(!auth.currentUser.email && !password) || !email}
          >{t`action.confirm`}</Button>
          <Button
            type="button"
            color="card"
            onClick={() => onClose("/settings/auth")}
          >
            {t`action.cancel`}
          </Button>
        </form>
      </div>
    </ModalLayout>
  );
});
